import { useContext } from "react";
import ServiceAuthContext from "contexts_and_providers/ServiceAuth/ServiceAuthContext";

const useServiceAuth = () => useContext(ServiceAuthContext);

export default useServiceAuth;
